
import {computed, defineComponent, provide, reactive, toRefs, watch} from 'vue'
import CloseIcon from '@/components/Icons/CloseIcon.vue'
import TickIcon from '@/components/Icons/TickIcon.vue'
import PenIcon from '@/components/Icons/PenIcon.vue'
import {cloneDeep, isEqual} from 'lodash'
import DButton from '@/components/base/DButton.vue'
import ToggleNew from '@/components/ToggleNew.vue'


export default defineComponent({
  name: 'EditableToggleBlock',
  components: { PenIcon, TickIcon, CloseIcon, DButton, ToggleNew },
  emits: ['update:editing', 'update:modelValue', 'update:switch-value'],

  props: {
    title: {
      type: String
    },
    editing: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object,
      default: () => ({})
    },
    switchProp: {
      type: String,
      required: true,
    },
    hideToggle: {
      type: Boolean
    },
    readonly: {
      type: Boolean
    }
  },

  setup (props, {emit}) {

    const state = reactive({
      editingInternal: props.editing,
      expanded: false,
    })

    watch(() => props.editing, (newValue) => state.editingInternal !== newValue && (state.editingInternal = newValue))
    watch(() => state.editingInternal, (newValue) => props.editing !== newValue && emit('update:editing', newValue))

    const editState = reactive({...cloneDeep(props.modelValue)})

    watch(
      () => props.modelValue,
      () => !props.editing && (Object.assign(editState, cloneDeep(props.modelValue)))
    )

    provide('editing', computed(() => state.editingInternal))

    const cancel = () => {
      Object.assign(editState, cloneDeep(props.modelValue))
      state.editingInternal = false
    }

    // Deep compares two objects and returns an object with the changed entries
    const compareObjects = (obj1, obj2) => {
      const differences = {}
      for (const key in obj1) {
        if (key in obj2) {
          if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
            if (!isEqual(obj1[key], obj2[key])) {
              differences[key] = obj2[key]
            }
          } else if (typeof obj1[key] === 'object' && obj1[key] !== null && typeof obj2[key] === 'object' && obj2[key] !== null) {
            const nestedDiff = compareObjects(obj1[key], obj2[key])
            if (Object.keys(nestedDiff).length > 0) {
              differences[key] = obj2[key]
            }
          } else if (obj1[key] !== obj2[key]) {
            differences[key] = obj2[key]
          }
        } else {
          differences[key] = undefined
        }
      }
      for (const key in obj2) {
        if (!(key in obj1)) {
          differences[key] = obj2[key]
        }
      }
      return differences
    }

    const save = () => {
      const changeProperties = compareObjects(props.modelValue, editState)
      state.editingInternal = false
      console.log(changeProperties)

      emit('update:modelValue', changeProperties)
    }

    const editingRef = reactive({
      value: computed({
        get: () => state.editingInternal,
        set: (val) => state.editingInternal = val
      })
    })

    const onToggle = (value) => {
      const changeProperties = compareObjects(props.modelValue, editState)
      editState[props.switchProp] = value
      if (Object.keys(changeProperties).length) {
        !state.editingInternal && (state.editingInternal = true)
        !state.expanded && (state.expanded = true)
      } else if (!value) {
        state.editingInternal = false
        state.expanded = false
      }
    }

    return {
      ...toRefs(state),
      editState,
      editingRef,
      cancel,
      save,
      onToggle,
    }
  }
})
